export default "__VITE_ASSET__CtRI88Wt__"